var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MdInput',{ref:"inputRef",attrs:{"value":_vm.value,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_setup.handleMdInput,"change":_setup.handleMdInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }